import React, { useState } from "react";

import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";

const BadgesEllipsisSoft = ({ objItems, sizePx }) => {
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  return (
    <React.Fragment>
      <div
        style={{
          width: sizePx,
        }}
      >
        {objItems.length > 2 ? (
          <div className="d-flex">
            {objItems.slice(0, 2).map((item, key) => (
              <div key={key} className="parent-badge-ellipsis d-inline-flex">
                <span
                  className="badge-ellipsis soft font-size-12 mr-2 badge-soft-success"
                >
                  {item.name}
                </span>
              </div>
            ))}
            <Dropdown
              className="d-inline-flex"
              // onClick={() => toggleModal()}
              onMouseEnter={() => toggleModal()}
              onMouseLeave={() => toggleModal()}
              isOpen={modal}
              nav={false}
              a11y={false}
            >
              <div className="d-inline-flex overflow-auto">
                <DropdownToggle
                  tag="span"
                  className="badge-ellipsis soft font-size-12 mr-2 badge-soft-success"
                >
                  +{objItems.length - 2}
                </DropdownToggle>
              </div>
              <DropdownMenu>
                {objItems.slice(2, objItems.length).map((item, key) => (
                  <div key={key} className="parent-badge-ellipsis d-flex">
                    <span
                      color="success"
                      className={
                        (item.name.length < 10
                          ? "badge-ellipsis soft"
                          : "badge-ellipsis soft-big") +
                        " badge-ellipsis-dropdown font-size-12 mx-2 my-1 badge-soft-success"
                      }
                    >
                      {item.name}
                    </span>
                  </div>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        ) : (
          <div className="d-flex">
            {objItems.map((item, key) => (
              <div key={key} className="parent-badge-ellipsis d-inline-flex">
                <span
                  className="badge-ellipsis soft font-size-12 mr-2 badge-soft-success"
                >
                  {item.name}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default BadgesEllipsisSoft;
